import { useEffect, useState, useRef } from 'react';

const useCollectionListener = (firebase, storeIds) => {
    const [newOrder, setNewOrder] = useState({ order: null, storeId: null });
    const [isInitialLoad, setIsInitialLoad] = useState(() => {
        return storeIds.reduce((acc, id) => {
          acc[id] = true;
          return acc;
        }, {});
    });

    const cleanOrder = () => {
        setNewOrder({ order: null, storeId: null });
    }

    useEffect(() => {
        const unsubscribeList = [];
        const updatedLoadStatus = { ...isInitialLoad };

        storeIds.forEach((storeId) => {
            const collectionPath = `salesChannel/${storeId}/newOrders`;
            const collectionRef = firebase.collection(collectionPath);
            const queryRef = collectionRef.orderBy('ts', 'desc').limit(1);
    
            const unsubscribe = queryRef.onSnapshot((snapshot) => {
                if (!snapshot.empty) {
                    const order = snapshot.docs[0].data();
                    const ts = new Date(order.ts).getTime()
                    const fromCache = snapshot.docs[0]._fromCache;
                    const differenceInSeconds = Math.floor((Date.now() - ts) / 1000);

                    if (updatedLoadStatus[storeId]) {
                        updatedLoadStatus[storeId] = false;
                    } else {
                        if (!fromCache && differenceInSeconds < 30) {
                            setNewOrder({ order, storeId });
                        }
                    }
                }
            },
            (error) => {
                console.log("Error fetching document: ", error);
            });

            unsubscribeList.push(unsubscribe);  
        });

        setIsInitialLoad(updatedLoadStatus)

        return () => {
            unsubscribeList.forEach(unsubscribe => unsubscribe());
        };
    }, []);

    return { ...newOrder, cleanOrder };
};

export default useCollectionListener;
